import findPrevNode from './find-prev-node';
import findLastTextNode from './find-last-text-node';

const findPrevTextContent = (element, relativeParentElement) => {
  let prevElement = findPrevNode(element, relativeParentElement);
  let targetNode = null;

  while (prevElement && !targetNode) {
    targetNode = findLastTextNode(prevElement, true);
    prevElement = findPrevNode(prevElement, relativeParentElement);
  }

  return targetNode;
};

export default findPrevTextContent;
